<template>
    <div class="home">
        <img src="../static/logo.png" class="logo" alt="">
        <img src="../static/mountain.png" class="mountain" alt="">
        <img src="../static/title.png" class="title" alt="">

       <a href="https://share.jcy.jinhua.com.cn/c/250317/TOP7lrVfOAlW5aojer.html?id=1758298" target="_blank" v-show="thebut" > <img src="../static/but.png" class="but"  alt=""></a>  


    </div>
</template>

<script>


export default {

    data() {
        return {
            thebut:false,
        }
    },
    methods: {

    },
    mounted() {
        setTimeout(() => {
            this.thebut=true
        }, 2000);
    },
}
</script>

<style lang="less">
.home {
    width: 375px;
    height: 100vh;
    background: url("../static/bg.jpg") no-repeat;
    background-size: 100% 100%;
    position: relative;
    overflow: hidden;

    .logo {
        position: absolute;
        width: 60px;
        left: 15px;
        top: 15px;
    }

    .mountain {
        position: absolute;
        width: 350px;
        left: 0;
        top: 30px;
        animation: an-mountain 1s ease-in 1 normal;

        @keyframes an-mountain {
            0% {
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }
    }

    .title {
        position: absolute;
        width: 290px;
        left: 50%;
        margin-left: -145px;
        top: 130px;
        animation: an-title 2s ease-out 1 normal;

        @keyframes an-title {
            0% {
           
                opacity: 0;

            }

            40% {
                transform: scale(0.2);
                opacity: 0;
            }

            100% {
                transform: scale(1);
                opacity: 1;

            }
        }
    }

    .but {
        position: absolute;
        width: 110px;
        bottom: 7%;
        margin-left: -55px;
        left: 50%;
        animation: thebut 1.5s linear infinite;

        @keyframes thebut {
            0% {
                transform: scale(1);
            }

            50% {
                transform: scale(1.1);
            }

            100% {
                transform: scale(1);
            }
        }
    }
}
</style>